import { render, staticRenderFns } from "./post-table.vue?vue&type=template&id=42b96781&scoped=true&"
import script from "./post-table.ts?vue&type=script&lang=ts&"
export * from "./post-table.ts?vue&type=script&lang=ts&"
import style0 from "./post-table.scss?vue&type=style&index=0&id=42b96781&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b96781",
  null
  
)

export default component.exports